import { Provider } from '@angular/core';
import { UserAccountFacade } from '../../root';
import { UserAccountService } from './user-account.service';

export const facadeProviders: Provider[] = [
  UserAccountService,
  {
    provide: UserAccountFacade,
    useExisting: UserAccountService,
  },
];
